import React, { useEffect, useState } from "react";
import "./subscription.css";
import { MdEdit } from "react-icons/md";
import ManageActivity from "./Manage";
import useFullPageLoader from "common/UseFullPageLoader";
import { planListApi } from "services/subscription";
import { firstWordCapital } from "utils/common";
import useUser from "hooks/useUser";

const ArticleManagementList = () => {
  const { havePermission } = useUser();
  const [loader, onShow, onHide] = useFullPageLoader();
  const [userList, setUserList] = useState([]);
  const [state, setState] = useState({
    manage: {
      isOpen: false,
      type: "",
      _id: "",
    },
    delete: {
      isOpen: false,
      _id: "",
    },
    status: "",
    category: "",
  });

  // user list handler
  const userListHandler = async () => {
    try {
      onShow();
      const reqData = {};
      const { data, status } = await planListApi(reqData);
      if (status === 200) {
        setUserList(data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    userListHandler();
  }, []);

  return (
    <>
      <div className="subscription_management">

        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
          {
            havePermission("subscription.write") &&
            <button
              type="button"
              className="button"
              onClick={() => {
                setState(prev => ({
                  ...prev,
                  manage: {
                    isOpen: true,
                    type: "CREATE",
                  }
                }))
              }}
            >
              Add Subscription
            </button>}
        </div>


        <div className="card">
          {
            userList.map((data) => {
              return <div className="card-body subcription_border">
                <div className="row">
                  <div className=" col-sm-6 col-md-12 col-lg-12">
                    <div className="subcription_parent">
                      <div className="subcription_wraper">
                        <div className="subcription_heading_wrap">
                          <p className="basic-heading">{data?.name}</p>
                          <p className="free-heading">
                            {
                              data?.price === 0
                                ?
                                "FREE"
                                :
                                `${data?.price} ${data?.currency}/ ${data?.duration === 1 ? "" : data?.duration} ${firstWordCapital(data?.interval?.toLowerCase())}`
                            }
                          </p>
                        </div>
                        {
                          havePermission("subscription.write") &&
                          <button className="button subscription_edit"
                            onClick={() => {
                              setState(prev => ({
                                ...prev,
                                manage: {
                                  isOpen: true,
                                  type: "EDIT",
                                  _id: data?._id
                                }
                              }))
                            }}>
                            <MdEdit />
                          </button>}
                      </div>
                      <div>
                        <p dangerouslySetInnerHTML={{ __html: data.description }} />
                      </div>

                      {/* <ul>
                        <li>Baby Diary Feature</li>
                        <li>Access upto 3 Recipes</li>
                        <li>Access upto 3 Activities & Games</li>
                        <li>Access upto 3 Articles</li>
                      </ul> */}
                    </div>
                  </div>
                </div>
              </div>
            })
          }
        </div>
      </div>

      {/* Add Edit */}
      <ManageActivity
        _id={state.manage._id}
        type={state.manage.type}
        isOpen={state.manage.isOpen}
        getListHandler={() => userListHandler()}
        onClose={() => setState(prev => ({ ...prev, manage: { isOpen: false } }))}
      />
    </>
  );
};

export default ArticleManagementList;
